module.exports = __webpack_public_path__ + "fonts/0ef29a7265f63d99063199bff1b9a685.svg";